import { z } from "zod";

import {
  CreateOrganizationDtoSchema,
  OrganizationDtoSchema,
} from "../../../dtos/organizations";

export const PostOrganizationRequestBodySchema = z.object({
  org: CreateOrganizationDtoSchema,
});

export type PostOrganizationRequestBodyType = z.infer<
  typeof PostOrganizationRequestBodySchema
>;

export const PostOrganizationResponseBodySchema = z.object({
  org: OrganizationDtoSchema,
});

export type PostOrganizationResponseBodyType = z.infer<
  typeof PostOrganizationResponseBodySchema
>;
